import { Injectable, computed, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { CurrentUserService } from './current-user.service';

/** Free-text climate commitments. Purely declarative, unrelated to reduction tips. */
@Injectable({ providedIn: 'root' })
export class CustomActionsService {
  private http = inject(HttpClient);
  private currentUserService = inject(CurrentUserService);

  customActions = computed<string[]>(
    () => this.currentUserService.currentUser()?.company?.customActions ?? [],
  );

  updateCustomActions(customActions: string[]): Observable<{ customActions: string[] }> {
    const companyId = this.currentUserService.currentUser()?.companyId ?? '';
    const previous = this.customActions();

    this.currentUserService.patchCompany({ customActions });

    return this.http
      .put<{ customActions: string[] }>(
        `${environment.apiUrl}/company/${companyId}/custom-actions`,
        { customActions },
      )
      .pipe(
        tap((result) => this.currentUserService.patchCompany({ customActions: result.customActions })),
        catchError((err) => {
          this.currentUserService.patchCompany({ customActions: previous });
          return throwError(() => err);
        }),
      );
  }
}
